module.exports = __webpack_public_path__ + "bca302eeffa19f22ef958c140ecf159f.png";